import type { Quote } from '../../types/quotes/quote'
import type { QuoteConvertEligibilityData } from '../../types/quotes/quoteConvertEligibilityData'

export const getQuoteConvertEligibilityData = (
  quote?: Pick<Quote, 'invoiceState' | 'status'>,
): QuoteConvertEligibilityData => ({
  invoiceState: quote?.invoiceState,
  quoteStatus: quote?.status?.status,
})
